//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/general-ledger/reports';
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        var sortOrders = {};
        return {
            sortKey: '',
            filterKey: '',
            sortOrders: sortOrders,
            pageNumber: 0,
            periodStart: moment().startOf('month'),
            periodEnd: moment().startOf('month'),
            glStart: null,
            glEnd: null,
            accounts: [],
            items: [],
            loading: true,
            showZeroBalance: true,
            exportExcel: false
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('gl-trial-balance-report', function () {
            _this.$children[0].showModal = true;
            _this.load();
        });

        Event.$on('exportArToExcel', function () {
            return alert('export');
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('gl-trial-balance-report');
        Event.$off('exportArToExcel');
    },

    methods: {
        applyFilter: function applyFilter() {
            this.load();
        },
        load: function load() {
            var _this2 = this;

            this.loading = true;

            axios.post(BASE_URL + '/trial-balance', { periodStart: this.periodStart, periodEnd: this.periodEnd }).then(function (response) {
                _this2.items = response.data;
                _this2.loading = false;
            });
        },
        exportToExcel: function exportToExcel() {
            this.loading = true;

            var data = {
                periodStart: this.periodStart, //@TODO: normalize these to start_date, end_date
                periodEnd: this.periodEnd,
                start_date: this.periodStart,
                end_date: this.periodEnd,
                exportExcel: true
            };

            this.createExport(data, BASE_URL + '/trial-balance', 'trial-balance', '.xlsx');

            this.loading = false;
        },
        exportToPdf: function exportToPdf() {
            this.loading = true;

            var data = {
                periodStart: this.periodStart, //@TODO: normalize these to start_date, end_date
                periodEnd: this.periodEnd,
                start_date: this.periodStart,
                end_date: this.periodEnd,
                exportPdf: true
            };

            this.createExport(data, BASE_URL + '/trial-balance', 'trial-balance', '.pdf');

            this.loading = false;
        }
    },
    computed: {
        filteredData: function filteredData() {
            if (this.showZeroBalance) {
                return this.items;
            } else {
                return this.items.filter(function (account) {
                    return account.current_balance > 0;
                });
            }
        },
        canPostTo: function canPostTo() {
            return this.accounts.filter(function (account) {
                return account.can_post_to === 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        },
        totalDebits: function totalDebits() {
            var amount = 0;
            this.items.map(function (item) {
                amount += Number(item.filteredDebits);
            });
            return amount;
        },
        totalCredits: function totalCredits() {
            var amount = 0;
            this.items.map(function (item) {
                amount += Number(item.filteredCredits);
            });
            return amount;
        },
        totalDifference: function totalDifference() {
            return Math.abs(Math.abs(this.totalDebits) - Math.abs(this.totalCredits));
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/reports/GlTrialBalanceReport.vue
// module id = 53Rk
// module chunks = 0 1